module.exports = __webpack_public_path__ + "static/media/screen3.512871af.jpg";